import validator from "cpf-cnpj-validator";
const Joi = require("@hapi/joi").extend(validator);


export default function ValidadCpfCnpj(value) {
 
  const cpfSchema = Joi.document().cpf();
  const cnpjSchema = Joi.document().cnpj();
  if(value.length === 14){
    const cpf = cpfSchema.validate(value);
    if(cpf.error){
      return false;
    }
  };
  if(value.length === 18){
    const cpnpj = cnpjSchema.validate(value);
    if(cpnpj.error){
      return false;
    }
  }
  return true;
}
